import React from 'react'
import DefaultLayout from 'js/components/DefaultLayout'
import { Link as HeadLink, Title } from 'react-head'
import Header from 'js/components/Header/Header'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import Footer from 'js/components/Footer/Footer'
import useLocale from 'js/hooks/useLocale'

const messages = defineMessages({
  Title: {
    id: 'getincontact_title',
    defaultMessage: 'Get in contact',
  },
  Heading: {
    id: 'getincontact_heading',
    defaultMessage: 'Get in contact',
  },
  Intro: {
    id: 'getincontact_intro',
    defaultMessage:
      'We want you to get in touch with the right person at Lifesum. Please select the area of interest below.',
  },
  ButtonText: {
    id: 'getincontact_button_text',
    defaultMessage: 'Contact Lifesum',
  },
  DescribePurpose: {
    id: 'getincontact_describe_purpose',
    defaultMessage:
      'Describe the purpose of your inquiry, and add your contact details as number, email, location.',
  },
  CareerSite: {
    id: 'getincontact_career_site',
    defaultMessage:
      'If you are searching for the opportunity to work at Lifesum, please have a look at our <a>Career site</a>.',
  },
  Partnership: {
    id: 'getincontact_partnership',
    defaultMessage: 'Partnership',
  },
  Ambassadorship: {
    id: 'getincontact_ambassadorship',
    defaultMessage: 'Ambassadorship',
  },
  Press: {
    id: 'getincontact_press',
    defaultMessage: 'Press',
  },
  Investors: {
    id: 'getincontact_investors',
    defaultMessage: 'Investors',
  },
  CustomerSupport: {
    id: 'getincontact_customer_support',
    defaultMessage: 'Customer Support',
  },
})
const listItemStyle = 'pb-24 type-fs'
export default function GetInContact() {
  const { formatMessage } = useIntl()
  const { language } = useLocale()

  const areas = [
    ['partners@lifesum.com', messages.Partnership],
    ['press@lifesum.com', messages.Press],
    ['ambassadors@lifesum.com', messages.Ambassadorship],
    ['investors@lifesum.com', messages.Investors],
  ] as const

  const localizedLink = `https://help.lifesum.com/${language}/`
  return (
    <DefaultLayout>
      <Title>{formatMessage(messages.Title)} - Lifesum</Title>
      <HeadLink rel="canonical" href="https://lifesum.com/contact/" />
      <Header inverted={false} />
      <div className="flex min-h-screen flex-col pt-128">
        <div className="flex grow flex-col items-center justify-center">
          <div className="max-w-480 px-16 md:px-40">
            <h1 className="mb-6 type-32 md:type-48 xl:type-56">
              <FormattedMessage {...messages.Heading} />
            </h1>
            <p>
              <FormattedMessage {...messages.Intro} />
            </p>
            <ul>
              <li className={listItemStyle}>
                <p className="mt-24">
                  <a
                    href={localizedLink}
                    className="font-demibold text-AccentBlue"
                  >
                    <FormattedMessage {...messages.CustomerSupport} />
                  </a>
                  : support@lifesum.com
                </p>
              </li>
              {areas.map((area, index) => {
                const [mail, label] = area
                return (
                  <li key={index} className={listItemStyle}>
                    <span>
                      <span className="font-demibold">
                        {formatMessage(label)}
                      </span>
                      : {mail}
                    </span>
                  </li>
                )
              })}
              <li className={listItemStyle}>
                <p>
                  <FormattedMessage
                    {...messages.CareerSite}
                    values={{
                      a: function CareerLink(...chunks) {
                        return (
                          <a
                            className="text-AccentBlue transition hover:text-inherit"
                            href="https://jobs.lifesum.com/"
                          >
                            {chunks}
                          </a>
                        )
                      },
                    }}
                  />
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="w-full">
          <Footer />
        </div>
      </div>
    </DefaultLayout>
  )
}
